import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useMarker } from '../utils/useMarker';
import { setCondition, setMultimodal, setProfil, setTime } from '../store/actions/profilActions';
import moment from 'moment';
import { setSelectedPath } from '../store/actions/directionsActions';
import { convertLocationFromUrl } from '../utils/queryUtils';

export const UrlEngine = ({
  origin,
  destination,
  profil,
  condition,
  multimodal,
  selectedPath,
  time
}) => {
  const dispatch = useDispatch();
  const {setMarker} = useMarker();

  const setParamsFromUrl = () => {
    const isTrueMultimodal = (multimodal === 'true');
    if (profil && profil !== null & profil !== '') {
      dispatch(setProfil(profil));
    }
    if (condition && condition !== null && condition !== '') {
      dispatch(setCondition(condition));
    }
    dispatch(setMultimodal(isTrueMultimodal));
    dispatch(setSelectedPath(Number(selectedPath)));
    if (origin && origin !== null && origin !== '') {
      const originValues = convertLocationFromUrl(origin);
      setMarker(originValues, 'origin');
    }
    if (destination && destination !== null && destination !== '') {
      const destValues = convertLocationFromUrl(destination);
      setMarker(destValues, 'destination');
    }
    if (time && time !== null && time !== '') {
      const timeFromUrl = moment(time);
      dispatch(setTime(timeFromUrl));
    } else {
      dispatch(setTime(moment()));
    }
  };

  useEffect(() => {
    if (origin || destination || profil || condition || multimodal || selectedPath || time) {
      setParamsFromUrl();
    }
  }, []);
  return null;
};